import { useQueryParams } from '@/hooks/useQueryParams'

/**
 * Feature toggles are located as a comma separated list of strings in the
 * "features" query param
 * e.g. event/123?features=cr-admin-view,foo
 * e.g. event/123?features=cr-admin-view&features=foo
 */
export const useFeatureFlag = (featureName: string): boolean => {
  const features = useQueryParams()
    .getAll('features')
    .flatMap(value => value.split(','))

  return features.includes(featureName)
}
